export const MaxCalendarMonths = 12 as const

export const MinBookingNights = 1 as const
